import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { QueueStatus } from '../api/models';


@Directive({
  selector: '[queueStatusStyle]',
  standalone: true
})
export class QueueStatusDirective implements OnInit {

  @Input() queueStatus: QueueStatus;

  constructor(private element: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.element.nativeElement.className=this.getCssClassList();
  }

  getCssClassList(): string {

    let classList = "tw-font-bold badge ";

    switch (this.queueStatus) {
      case QueueStatus.Failed:
      case QueueStatus.FailedExtract:
      case QueueStatus.Rejected:
        classList += "badge-light-danger"
        break;
      case QueueStatus.Ready:
        classList += "badge-light-blue"
        break;
      case QueueStatus.Stored:
        classList += "badge-light-navyBlue"
        break;
      case QueueStatus.WatingForConfirm:
        classList += "badge-light-info"
        break;

      // case QueueStatus.Completed:
      // case QueueStatus.Confirmed:
      //   classList += "badge-light-success"
      //   break;
      case QueueStatus.Updating:
        classList += "badge-light-warning"
        break;

      default:
        break;
    }

    return classList;
  }





}

